<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs,on }">
      <v-btn icon v-on="on" v-bind="attrs" color="warning darken-3">
        <v-icon right>fas fa-user-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="error headline white--text"
        >Edite Date Form
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-3">
        <v-form v-model="valid" ref="withDrowform">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>

          <v-text-field
            :readonly="Disable.Details"
            name="InfoFildName"
            label="Details"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Save Edite</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    // AccountNumber: [String],
    Disable: {
      type: Object,
      default: () => ({ Details: false }),
    },
    Info: { type: Object, required: true },
    BaseURL: { type: String, required: true },
    FinishedWithdrow: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {
      ErrMsg: "",
      loading: false,
      dialog: false,
      valid: false,
      PayDate: "",
      //   Amount: 0,
      Details: "",
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          this.PayDate = this.Info.date;
          this.Details = this.Info.Details;
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
        });
      }
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";

      this.PayDate = "";
      this.Details = "";
      this.$refs.withDrowform.resetValidation();
    },

    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.withDrowform.validate()) {
        let data = {
          Details: this.Details,
          date: this.PayDate,
          Ref: this.Info.Ref,
        };
        this.loading = true;
        this.$store
          .dispatch("UPDATE_ONLY", { url: this.BaseURL + "/Editedate", data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.FinishedWithdrow();
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
  },
};
</script>
